<template>
  <section class="-left">
    <a :href="href" :class="linkClasses" @click.prevent="visualizarPdfDiario">
      <svg v-if="iconName" :class="svgClasses">
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          :href="`/assets/svg/user/icons.svg#${iconName}`"
        ></use>
      </svg>
      <span>{{ label }}</span>
    </a>
    <modal-confirmar-email
      :loading="false"
      :email="email"
    ></modal-confirmar-email>
    <modal-campaign
      v-if="showModalCampaign"
      :campaign="campaign"
      @close="closeModalCampaign"
    />
  </section>
</template>
<script>
import * as modals from "./../../store/modal-types";
import * as types from "./../../store/mutation-types";
import ModalConfirmarEmail from "../monitoramentos/ModalConfirmarEmail";
import ModalCallToActionAssinatura from "../../components/modals/ModalCallToActionAssinatura";
import ModalCampaign from "../../components/modals/ModalCampaign";
export default {
  components: {
    ModalConfirmarEmail,
    ModalCallToActionAssinatura,
    ModalCampaign
  },
  props: {
    linkClasses: {
      default: "btn -hasIcon",
      type: String
    },
    svgClasses: {
      default: "svg-icon -x20 -right -highlight",
      type: String
    },
    href: {
      default: "#",
      type: String
    },
    email: {
      default: "",
      type: String
    },
    label: {
      default: "Visualizar PDF",
      type: String
    },
    confirmouEmail: {
      default: true,
      type: Boolean
    },
    podeBaixarPdf: {
      default: false,
      type: Boolean
    },
    iconName: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      showModalCampaign: false,
      campaign: {
        id: 62,
        title:
          "Você atingiu o limite mensal de PDFs de páginas de Diários Oficiais",
        titleNonSubscriber: "O PDF está disponível apenas para assinantes",
        subscriber:
          "Mude para um plano que seja mais adequado às suas necessidades.",
        nonSubscriber:
          "Assine um de nossos planos e desbloqueie o acesso aos PDFs",
        footer: "Faça mais a partir de ",
        planKey: "quantidade_pdfs"
      }
    };
  },
  mounted() {
    this.$store.dispatch("getAuthUser");
  },
  methods: {
    toggleModalConfirmarEmail() {
      this.$store.commit(types.TOGGLE_MODAL, modals.CONFIRMAR_EMAIL);
    },
    openModalCampaign() {
      this.showModalCampaign = true;
    },
    closeModalCampaign() {
      this.showModalCampaign = false;
    },
    visualizarPdfDiario() {
      if (!this.confirmouEmail) {
        this.toggleModalConfirmarEmail();
        return;
      }

      if (!this.podeBaixarPdf) {
        this.openModalCampaign();
        return;
      }

      window.location = this.href;
    },
    baixarPdfDiario(diarioId, siglaDiario, tipoUrl, dataDiario, paginaDiario) {
      let errors;
      const dataDiarioFormatada = moment(dataDiario).format("YYYY-MM-DD");
      this.$store
        .dispatch("baixarPdfDiario", {
          diarioId,
          siglaDiario,
          tipoUrl,
          dataDiarioFormatada,
          paginaDiario
        })
        .catch(({ response }) => {
          const responseData = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(response.data))
          );
          if (typeof responseData === "object" && responseData !== null) {
            errors = Object.keys(responseData).map(k => responseData[k][0]);
            if (responseData.plano) {
              this.openModalCampaign();
            } else if (responseData.email) {
              this.toggleModalConfirmarEmail();
            }
          }
        });
    }
  }
};
</script>
<style lang="stylus">
.is-hidden
  display none
</style>
